import { useRef } from "react";
import {
  Button, ButtonSize, ButtonVariant
} from '@repo/design-system/components/ui';
import PropTypes from "prop-types";
import "./FilePreview.scss";
import FileViewHandler from './feature/FileViewHandler';

const FilePreview = ({
  fileValues = [],
  isMultipleFileAllowed = false,
  onClearClick,
  onActionClick,
  onClearAll,
  isDownloadButton,
  fieldSetting,
  isDisable,
  selectedFileObj
}) => {

  if (!fileValues?.some(v => v != null)) return null;

  const fileViewRef = useRef();

  const handleViewFile = (file, index) => {
    onActionClick(index, "VIEW");
    const selectedData = selectedFileObj[index];
    if (fileViewRef?.current) {
      fileViewRef?.current.fileViewImperative(selectedData);
    }
  };

  return (
    <>
      <div className={` file-preview ${isMultipleFileAllowed ? "file-preview--multiple" : "file-preview--single"}
        ${isDisable ? "file-preview--disabled" : ""}`}>
        {isMultipleFileAllowed && (
          <div className="file-preview__header">
            <h4 className="file-preview__title">Attached Files</h4>
            <Button variant={ButtonVariant.SECONDARY} size={ButtonSize.SM}
              onClick={onClearAll} disabled={isDisable} aria-label="Clear all files">
              Clear All
            </Button>
          </div>
        )}
        <div className="file-preview__list">
          <div className="file-preview__list-head">
            <span>File</span>
            <span>Actions</span>
          </div>

          <div className="file-preview__list-divider">
            {fileValues.map((file, index) => (
              <div key={index} className="file-preview__list-row mb-2">
                <div className="file-preview__file">
                  <p className="file-preview__file-name" title={file.name}>
                    {file.name}
                  </p>
                </div>

                <div className={` file-preview__actions ${isMultipleFileAllowed
                  ? "file-preview__actions--multiple" : "file-preview__actions--single"}`}>
                  {fieldSetting?.isViewButton &&
                    <Button variant={ButtonVariant.SECONDARY} size={ButtonSize.SM} className="me-2"
                      rightIcon="lucide:eye" onClick={() => handleViewFile(file, index)}
                      aria-label="View file" ttLabel="View" targetId="viewFile" />
                  }
                  {isDownloadButton && (
                    <Button variant={ButtonVariant.SECONDARY} size={ButtonSize.SM} className="me-2"
                      rightIcon="basil:download-outline" onClick={() => onActionClick(index, "DOWNLOAD")}
                      aria-label="Download file" ttLabel="Download" targetId="downloadFile" />
                  )}
                  <Button variant={ButtonVariant.SECONDARY} rightIcon="fluent:delete-16-regular"
                    size={ButtonSize.SM} onClick={() => onClearClick(index)}
                    disabled={isDisable} aria-label="Remove file" ttLabel="Remove" targetId="removeFile" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <FileViewHandler ref={fileViewRef} fieldSetting={fieldSetting} />
    </>
  );
};


FilePreview.propTypes = {
  fileValues: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
      size: PropTypes.number,
    })
  ).isRequired,
  isMultipleFileAllowed: PropTypes.bool,
  onClearClick: PropTypes.func.isRequired,
  onActionClick: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  isDownloadButton: PropTypes.bool,
};

export default FilePreview;
